import { Text } from '@public/components/UI/Typography/Text';
import { useRouter } from 'next/router';

import styles from './TeamSummaryHeaders.module.scss';

interface ITeamSummaryHeadersProps {
  totalDrafted?: number | null;
  orgAbbreviation?: string | null;
}

export const TeamSummaryHeaders = ({
  totalDrafted,
  orgAbbreviation,
}: ITeamSummaryHeadersProps) => {
  const router = useRouter();
  const { year, 'year-span': span } = router.query;
  const spanOfYears = span && year ? `${+year - +span + 1}-${year}` : '';
  const association = router.asPath.includes('nba') ? 'NCAAB' : 'NCAAF';

  return (
    <ul className={styles.rowHeaders}>
      <Text className={styles.totalContainer} component="li">
        <span className={styles.labelTotal}>{`${association} total`}</span>
        {span && <div className={styles.spanOfYears}>{spanOfYears}</div>}
        <span className={styles.labelDrafted}>drafted</span>
        <Text className={styles.totalDrafted} component="span" variant="h1">
          {totalDrafted ?? '-'}
        </Text>
      </Text>
    </ul>
  );
};
